exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "[data-v-221a1400] .expansion-panel__container{border-top:0!important}[data-v-221a1400] .expansion-panel__header{-ms-flex-direction:row-reverse;flex-direction:row-reverse}[data-v-221a1400] .expansion-panel__header div{margin:5px}[data-v-221a1400] .checkbox label{color:rgba(0,0,0,.87)!important}.checkbox-padding-test[data-v-221a1400]{padding-left:29px}img[data-v-221a1400]{max-width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-221a1400","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/dialog/types/DialogIncludeDICOM.vue
// module id = 1075
// module chunks = 22